"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferExistsDtoSignatureStatusEnum = exports.OfferExistsDtoStatusEnum = void 0;
exports.instanceOfOfferExistsDto = instanceOfOfferExistsDto;
exports.OfferExistsDtoFromJSON = OfferExistsDtoFromJSON;
exports.OfferExistsDtoFromJSONTyped = OfferExistsDtoFromJSONTyped;
exports.OfferExistsDtoToJSON = OfferExistsDtoToJSON;
exports.OfferExistsDtoToJSONTyped = OfferExistsDtoToJSONTyped;
/**
 * @export
 */
exports.OfferExistsDtoStatusEnum = {
    Draft: 'draft',
    UnderReview: 'under_review',
    Pending: 'pending',
    Reserved: 'reserved',
    Accepted: 'accepted',
    Rejected: 'rejected',
    Countered: 'countered',
    Withdrawn: 'withdrawn',
    Expired: 'expired',
    Closed: 'closed'
};
/**
 * @export
 */
exports.OfferExistsDtoSignatureStatusEnum = {
    OfferorSignPending: 'offeror_sign_pending',
    OfferorSigned: 'offeror_signed',
    OffereeSignPending: 'offeree_sign_pending',
    OffereeSigned: 'offeree_signed'
};
/**
 * Check if a given object implements the OfferExistsDto interface.
 */
function instanceOfOfferExistsDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('offerPrice' in value) || value['offerPrice'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('signatureStatus' in value) || value['signatureStatus'] === undefined)
        return false;
    return true;
}
function OfferExistsDtoFromJSON(json) {
    return OfferExistsDtoFromJSONTyped(json, false);
}
function OfferExistsDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'offerPrice': json['offerPrice'],
        'depositAmount': json['depositAmount'] == null ? undefined : json['depositAmount'],
        'settlementDate': json['settlementDate'] == null ? undefined : json['settlementDate'],
        'expiresAt': json['expiresAt'] == null ? undefined : json['expiresAt'],
        'createdAt': json['createdAt'] == null ? undefined : json['createdAt'],
        'updatedAt': json['updatedAt'] == null ? undefined : json['updatedAt'],
        'status': json['status'],
        'signatureStatus': json['signatureStatus'],
    };
}
function OfferExistsDtoToJSON(json) {
    return OfferExistsDtoToJSONTyped(json, false);
}
function OfferExistsDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'offerPrice': value['offerPrice'],
        'depositAmount': value['depositAmount'],
        'settlementDate': value['settlementDate'],
        'expiresAt': value['expiresAt'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'status': value['status'],
        'signatureStatus': value['signatureStatus'],
    };
}
